<template>
  <router-link :to="bannerLink || '/'" v-if="!hideBanner && (desktopBanner || mobileBanner)">
    <img v-if="desktopBanner" :src="desktopBanner" class="w-100 d-none d-md-block" alt="Banner Image" />
    <img v-if="mobileBanner" :src="mobileBanner" class="w-100 d-block d-md-none" alt="Banner Image" />
  </router-link>
</template>

<script>
export default {
  name: "ImageBanner",
  props: {
    bannerLink: String,
    desktopBanner: String,
    mobileBanner: String,
    showChallengesBanner: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    hideBanner() {
      let path = this.$route.path;
      if(this.showChallengesBanner && path === '/user/challenges') return false;
      if (!this.bannerLink) return false;
      if (path.startsWith('/user/challenge/')) return true;
      return path.startsWith(this.bannerLink);
    }
  }
}
</script>
